import React, { forwardRef, useEffect, useState, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Helpers } from './helpers/helpers';
import Overlay from 'react-bootstrap/lib/Overlay';
import isFunction from "lodash/isFunction";

const DropDownBtn = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [targetRef, setTargetRef] = useState(null);
  const [containerRef, setContainerRef] = useState(null);
  const {
    containerClassName,
    buttonId,
    buttonClassName,
    buttonDataValue,
    buttonShownValue,
    buttonChildren,
    children,
    mobileViewOff,
    style,
    openOnLoad
  } = props;

  useEffect(() => {
    if (openOnLoad) {
      setShow(true);
    }
  }, []);

  const toggleShow = () => {
    setShow(!show);
  };

  const hideDropDown = () => {
    const { onHideFn } = props;
    setShow(false);
    if (isFunction(onHideFn)) onHideFn();
  };

  useImperativeHandle(ref, () => ({
    hideDropDown
  }));

  const isMobile = Helpers.isMobile();
  const listComponent = React.cloneElement(children, { listToggle: toggleShow });
  return (
    <div ref={setContainerRef} className={`dropdown-container ${containerClassName || ''}`}>
      <button
        type="button"
        id={buttonId || null}
        className={`btn btn-default btn-block ${buttonClassName || ''} btn-outlined-light`}
        onClick={toggleShow}
        style={style}
        ref={setTargetRef}
      >
        {
          buttonChildren
            ? React.cloneElement(buttonChildren, { show })
            :
            <div>
              <span className="dropdown-value ellipsis" data-value={buttonDataValue}>
                {buttonShownValue}
              </span>
              <span className={show ? 'arrow up' : 'arrow'} />
            </div>
        }
      </button>
      {
        isMobile && !mobileViewOff
          ? listComponent
          :
          targetRef &&
          <Overlay
            container={containerRef}
            show={show}
            placement="bottom"
            target={targetRef}
            rootClose
            onHide={hideDropDown}
          >
            { listComponent }
          </Overlay>
      }
    </div>
  );
});

DropDownBtn.propTypes = {
  buttonId: PropTypes.string,
  buttonDataValue: PropTypes.string,
  buttonShownValue: PropTypes.string,
  containerClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  buttonChildren: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  mobileViewOff: PropTypes.bool,
  style: PropTypes.object,
  onHideFn: PropTypes.func,
  openOnLoad: PropTypes.bool,
};

exports.DropDownBtn = DropDownBtn;
